import { render, staticRenderFns } from "./UsuarioNoAutorizado.vue?vue&type=template&id=0fec8ccc&scoped=true"
import script from "./UsuarioNoAutorizado.vue?vue&type=script&lang=js"
export * from "./UsuarioNoAutorizado.vue?vue&type=script&lang=js"
import style0 from "./UsuarioNoAutorizado.vue?vue&type=style&index=0&id=0fec8ccc&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0fec8ccc",
  null
  
)

export default component.exports